module.exports = __webpack_public_path__ + "static/media/lg-white-pine-pond-1.954f0010.jpg";